import {RootState} from "../store";
import {createSelector} from "@reduxjs/toolkit";

// sign-up state
export const alertsStateSelector = (state: RootState) => state.alerts;

export const alertsSelector = createSelector(
  alertsStateSelector,
  (state) => state
);
